export default __webpack_public_path__ + "static/media/Group1625@2x.0a796b4c.png";